// import data from "./data.json";

type MatrixAsset = {
    assetId: number;
    assetName: string;
    assetStatusCode: number;
    glossaryDefinition: string;
    glossaryCaseSensitive: boolean;
    glossaryAka: string;
    glossaryNolink: boolean;
    glossaryAssetExclusions: string[] | null;
};

type GlossaryTerm = Pick<
    MatrixAsset,
    | "assetName"
    | "glossaryDefinition"
    | "glossaryCaseSensitive"
    | "glossaryAssetExclusions"
> & {
    item: MatrixAsset;
};

type TableTerm = {
    term: string | null;
    definition: string | null;
};

(function () {
    "use strict";

    const doctrineElement = document.querySelector(
        "[data-doctrine]"
    ) as HTMLElement;

    document.addEventListener("DOMContentLoaded", () => {
        // @ts-ignore
        const glossary: MatrixAsset[] = glossaryData || [];
        // const glossary: MatrixAsset[] = data;

        // Flatten the glossary and sort terms by length in descending order
        const flattenedGlossary: GlossaryTerm[] = [];

        glossary.forEach((item) => {
            const {
                assetName,
                glossaryDefinition,
                glossaryCaseSensitive,
                glossaryAka,
                glossaryNolink,
                glossaryAssetExclusions,
            } = item;
            // Add the main term if it isn't excluded by either metadata or page exclusion
            // May need to add url string array for wider site range
            const pageExclusions = glossaryAssetExclusions || [];

            if (
                !glossaryNolink &&
                // @ts-ignore
                !pageExclusions.includes(doctrineId) // TODO: look a this
            ) {
                flattenedGlossary.push({
                    assetName,
                    glossaryDefinition,
                    glossaryCaseSensitive,
                    glossaryAssetExclusions: pageExclusions,
                    item,
                });
                // Add AKAs; skip empty segments from trailing/leading semicolons
                if (glossaryAka) {
                    glossaryAka.split(";").forEach((aka) => {
                        const trimmed = aka.trim();
                        if (trimmed) {
                            flattenedGlossary.push({
                                assetName: trimmed,
                                glossaryDefinition,
                                glossaryCaseSensitive,
                                glossaryAssetExclusions,
                                item,
                            });
                        }
                    });
                }
            }
        });

        flattenedGlossary.sort(
            ({ assetName: first }, { assetName: second }) => {
                return second.length - first.length;
            }
        );

        // Debug
        console.log("Flattened Glossary:", flattenedGlossary);

        function removeExistingSpans(element: HTMLElement) {
            const spans = element.getElementsByTagName("span");
            while (spans.length) {
                const span = spans[0];
                const parent = span.parentNode!;
                while (span.firstChild) {
                    parent.insertBefore(span.firstChild, span);
                }
                parent.removeChild(span);
            }
        }

        function isAncestorWithClass(node: HTMLElement, className: string) {
            while (node) {
                if (node.nodeType === 1 && node.classList.contains(className)) {
                    return true;
                }
                node = node.parentNode as HTMLElement;
            }
            return false;
        }

        function isAncestorWithTag(node: HTMLElement, tagName: string) {
            while (node) {
                if (
                    node.nodeType === 1 &&
                    node.tagName === tagName.toUpperCase()
                ) {
                    return true;
                }
                node = node.parentNode as HTMLElement;
            }
            return false;
        }

        function isAncestorWithHeadingTag(node: HTMLElement) {
            while (node) {
                if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
                    return true;
                }
                node = node.parentNode as HTMLElement;
            }
            return false;
        }

        function replaceGlossaryTerms() {
            const replacedTerms: string[] = [];

            removeExistingSpans(doctrineElement!);

            const processedEntries = new Set();

            flattenedGlossary.forEach(
                ({
                    item,
                    assetName,
                    glossaryDefinition,
                    glossaryCaseSensitive,
                }) => {
                    if (processedEntries.has(item)) {
                        return;
                    }

                    let regex;

                    if (glossaryCaseSensitive) {
                        regex = new RegExp("\\b" + assetName + "\\b", "g");
                    } else {
                        regex = new RegExp("\\b" + assetName + "\\b", "gi");
                    }

                    const walker = document.createTreeWalker(
                        doctrineElement!,
                        NodeFilter.SHOW_TEXT,
                        null
                    );
                    let node: HTMLElement;
                    while ((node = walker.nextNode() as HTMLElement)) {
                        if (
                            !isAncestorWithClass(node, "glossary-term") &&
                            !isAncestorWithTag(node, "A") &&
                            !isAncestorWithHeadingTag(node)
                        ) {
                            const text = node.nodeValue;

                            const replacedText = text!.replace(
                                regex,
                                (match) => {
                                    if (
                                        replacedTerms.indexOf(assetName) === -1
                                    ) {
                                        replacedTerms.push(assetName);
                                        processedEntries.add(item);
                                        return `<span class="glossary-term" data-definition="${glossaryDefinition}">${match}</span>`;
                                    }
                                    return match;
                                }
                            );
                            if (replacedText !== text) {
                                const span = document.createElement("span");
                                span.innerHTML = replacedText;
                                node!.parentNode!.replaceChild(span, node);
                            }
                        }
                    }
                }
            );

            // console.log("Glossary terms replaced: " + replacedTerms.length);
            // console.log("Replaced terms: " + replacedTerms.join(", "));
        }

        if (doctrineElement) {
            replaceGlossaryTerms();
            // console.log('Element id="doctrine" found. Running glossary function');
        }
    });

    document.addEventListener("DOMContentLoaded", () => {
        const glossaryTerms = document.querySelectorAll(".glossary-term");

        glossaryTerms.forEach((term) => {
            if (term instanceof HTMLElement)
                term.onmouseover = () => {
                    const tooltip = document.createElement("div");
                    tooltip.textContent = term.getAttribute("data-definition");
                    // .replace(/<\/?[^>]+(>|$)/g, "");
                    tooltip.style.position = "absolute";
                    tooltip.style.left = "50%";
                    tooltip.style.transform = "translateX(-50%)";
                    tooltip.style.backgroundColor = "#e0e0e0";
                    tooltip.style.border = "1px solid #cccccc";
                    tooltip.style.color = "#333";
                    tooltip.style.padding = "0.5em";
                    tooltip.style.maxWidth = "80%";
                    tooltip.style.whiteSpace = "normal";
                    tooltip.style.zIndex = "1000";

                    // Append tooltip to the body to calculate its size
                    document.body.appendChild(tooltip);

                    // Determine if there's enough space above the term; if not, adjust
                    const termRect = term.getBoundingClientRect();
                    if (termRect.top < tooltip.offsetHeight + 10) {
                        // Not enough space above
                        tooltip.style.top =
                            termRect.bottom + window.scrollY + 10 + "px";
                    } else {
                        // Enough space above
                        tooltip.style.top =
                            termRect.top +
                            window.scrollY -
                            tooltip.offsetHeight -
                            10 +
                            "px";
                    }

                    // Remove the tooltip on mouseout
                    term.onmouseout = () => {
                        document.body.removeChild(tooltip);
                    };
                };
        });
    });

    document.addEventListener("DOMContentLoaded", () => {
        const glossaryTerms = document.querySelectorAll(".glossary-term");
        let definitionsContent =
            '<h2 class="definitions-print-only" >Definitions</h2>'; // Adding H2 heading
        let definitionsTable =
            '<table class="definitions-print-only" style="border-collapse: collapse; width: 100%;">';

        // Adding header row
        definitionsTable +=
            '<thead><tr><th style="border: 1px solid black; padding: 5px;">Term</th><th style="border: 1px solid black; padding: 5px;">Definition</th></tr></thead><tbody>';

        const tableTerms: TableTerm[] = []; // Array to hold terms and definitions

        glossaryTerms.forEach((term) => {
            const definition = term.getAttribute("data-definition");
            const termText = term.textContent;

            // Add term and definition to array
            tableTerms.push({ term: termText, definition: definition });
        });

        // Sort the termsArray alphabetically based on the term
        tableTerms.sort(({ term: first }, { term: second }) => {
            return first!.localeCompare(second!);
        });

        const addedTerms = new Set(); // Set to track added terms

        // Iterate over sorted array to add terms to the table
        tableTerms.forEach((item) => {
            if (!addedTerms.has(item.term)) {
                definitionsTable +=
                    '<tr><td style="border: 1px solid black; padding: 5px;">' +
                    item.term +
                    '</td><td style="border: 1px solid black; padding: 5px;">' +
                    item.definition +
                    "</td></tr>";
                addedTerms.add(item.term); // Add term to the Set to track added terms
            }
        });

        definitionsTable += "</tbody></table>";
        definitionsContent += definitionsTable;
        // Find the policy disclaimer div and insert the definitions after it
        const policyDisclaimerDiv = document.querySelector(
            "[data-policy-disclaimer]"
        );

        if (policyDisclaimerDiv) {
            policyDisclaimerDiv.insertAdjacentHTML(
                "beforebegin",
                definitionsContent
            );
        }
    });
})();
